import React, { useState } from "react";
import { getDatabase, ref, set, update, remove } from "firebase/database";
import Modal from "react-modal";
import "./QuestionComponent.css";
import { VscCheck } from "react-icons/vsc";
import { VscClose } from "react-icons/vsc";
import { VscTrash } from "react-icons/vsc";

const QuestionComponent = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [questionName, setQuestionName] = useState("");
  const [text, setText] = useState(props.text);
  const [correctOption, setCorrectOption] = useState(props.correctOption);
  const [options, setOptions] = useState(props.options);
  const [interviewerName, setInterviewerName] = useState(props.interviewerName);
  const [interviewerTitle, setInterviewerTitle] = useState(
    props.interviewerTitle
  );
  const [assetURL, setAssetURL] = useState(props.assetUrl);
  const [explanationAssetURL, setExplanationAssetURL] = useState(
    props.explanationAssetUrl
  );
  const [inputFieldsError, setInputFieldsError] = useState("");

  const emptyInputStringsValidation = () => {
    return (
      text != "" &&
      correctOption != "" &&
      options.length >= 1 &&
      options[0] != "" && // adittion list emptity check
      interviewerName != "" &&
      interviewerTitle != "" &&
      assetURL != "" &&
      explanationAssetURL != ""
    );
  };

  const updateQuestion = (
    text,
    correctOption,
    options,
    interviewerName,
    interviewerTitle,
    assetURL,
    explanationAssetURL
  ) => {
    const db = getDatabase();
    const postData = {
      text: text,
      correctOption: parseFloat(correctOption),
      options: options,
      interviewerName: interviewerName,
      interviewerTitle: interviewerTitle,
      assetURL: assetURL,
      explanationAssetURL: explanationAssetURL,
    };

    if (emptyInputStringsValidation()) {
      update(ref(db, "questions/" + props.question), postData);
      setInputFieldsError(emptyInputStringsValidation());
      setModalIsOpen(false);
    } else {
      setInputFieldsError(emptyInputStringsValidation());
    }
  };

  const removeQuestion = () => {
    const db = getDatabase();
    remove(ref(db, "questions/" + props.question));
    setModalIsOpen(false);
  };

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        closeTimeoutMS={200}
        onRequestClose={() => setModalIsOpen(false)}
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
          },
          content: {
            position: "absolute",

            width: "30%",
            height: "65%",

            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "15px",
            outline: "none",
            padding: "35px",
            paddingLeft: "45px",

            border: "0",
            bottom: "auto",
            minHeight: "10rem",
            left: "50%",
            position: "fixed",
            right: "auto",
            top: "50%",
            transform: "translate(-50%,-50%)",
            minWidth: "20rem",
            maxWidth: "60rem",
          },
        }}
      >
        <div className="question-component-modal-body">
          <div className="modal-title">
            <h1>{props.question}</h1>
            <button
              className="close-modal-btn"
              onClick={() => setModalIsOpen(false)}
            >
              <VscClose size={"20px"} color="grey" />
            </button>
          </div>
          <div className="question-component-modal-input-fields">
            <input
              className="modal-input"
              placeholder="Text"
              value={text}
              onChange={(e) => {
                setText(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Correct Option"
              value={correctOption}
              onChange={(e) => {
                setCorrectOption(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Options"
              value={options.join(", ")}
              onChange={(e) => {
                setOptions(e.target.value.split(", "));
              }}
            />
            <input
              className="modal-input"
              placeholder="Interviewer Name"
              value={interviewerName}
              onChange={(e) => {
                setInterviewerName(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Interviewer Title"
              value={interviewerTitle}
              onChange={(e) => {
                setInterviewerTitle(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Asset URL"
              value={assetURL}
              onChange={(e) => {
                setAssetURL(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Explanation Asset URL"
              value={explanationAssetURL}
              onChange={(e) => {
                setExplanationAssetURL(e.target.value);
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              marginTop: "8%",
              alignItems: "center",
              justifyContent: "space-between",
              marginRight: "7%",
            }}
          >
            <button
              className="submit-button"
              onClick={() =>
                updateQuestion(
                  text,
                  correctOption,
                  options,
                  interviewerName,
                  interviewerTitle,
                  assetURL,
                  explanationAssetURL
                )
              }
            >
              Update question
            </button>

            <button
              style={{ background: "none", border: "none", cursor: "pointer" }}
              onClick={() => removeQuestion()}
            >
              <VscTrash color="red" size={20} />
            </button>
          </div>
        </div>
      </Modal>
      <div className="question-component" onClick={() => setModalIsOpen(true)}>
        <div className="question-component-question">
          {props.question != null ? props.question : 0}
        </div>
        <div className="question-component-text">
          {props.text != null ? props.text : 0}
        </div>
        <div className="question-component-options">
          {props.options != null
            ? props.options.map((option) => <li>{option}</li>)
            : 0}
        </div>
        <div className="question-component-correct-option">
          {props.correctOption != null ? props.correctOption : 0}
        </div>

        <div className="question-component-interviewer-name">
          {props.interviewerName != null ? props.interviewerName : 0}
        </div>
        <div className="question-component-interview-title">
          {props.interviewerTitle != null ? props.interviewerTitle : 0}
        </div>
        <div className="question-component-asset-url">
          {props.assetUrl != null ? (
            <VscCheck color="green" size={"17px"} />
          ) : (
            <VscClose color="red" size={"17px"} />
          )}
        </div>
        <div className="question-component-explanation-asset-url">
          {props.explanationAssetUrl != null ? (
            <VscCheck color="green" size={"17px"} />
          ) : (
            <VscClose color="red" size={"17px"} />
          )}
        </div>
      </div>
    </div>
  );
};

export default QuestionComponent;